export default "__VITE_ASSET__BkntnDAt__"